<template>
  <div>
    <el-row>
      <el-col :span="24"
      >
        <el-form-item
          label="分摊对象"
          :label-width="formLabelWidth">
          <el-switch
            v-model="iffentan"
            active-value="1"
            inactive-value="0"
            active-color="#13ce66"
            inactive-color="#DCDCDC"
            @change="FentanSwitchChange">
          </el-switch>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="iffentan=='1'">
      <el-col :span="4">&nbsp;</el-col>
      <el-col :span="20">
        <CommTreeViewDialog
          ref="applyTree"
          @check="afterSelectApply"
          :options="applyTreeOption"
        ></CommTreeViewDialog>
        <el-row v-for="(offset,index) in fentanDetailjson" :key="index"
                style="padding-left: 20px;padding-bottom: 20px;">
          <el-col>
            <el-input type="text" placeholder="选择分摊人员" readonly style="width: 100px;"
                      v-model="offset.applyby||offset.applybydname"
                      @click.native="openSelectApply(index)"></el-input>
            <el-input-number
              v-model="offset.fentanmoney"
              auto-complete="off"
              :required="true"
              :controls="false"
              :max="totalfeemoney"
              :min="0.00"
              @blur="onFentanmoneychange(index)"
              style="width: 140px"
            ></el-input-number>
            <el-input-number
              v-model="offset.percent"
              auto-complete="off"
              :required="true"
              :controls="false"
              :max="100"
              :min="0.01"
              @blur="onPercentChange(index)"
              style="width: 60px" placeholder="比例"
            ></el-input-number>
            %
            <span v-if="formallowedit">
            <el-button
              type="primary" icon="el-icon-plus" circle size="small"
              v-if="index==0 "
              @click.prevent="addOffset()"
              round
            ></el-button>
            <el-button
              type="danger" icon="el-icon-delete" circle size="small"
              v-if="index>0"
              @click.prevent="removeOffset(offset)"
              round
            ></el-button>
          </span>
          </el-col>
        </el-row>
        <!--<el-form-item-->
        <!--v-for="(offset,index) in fentanDetailjson"-->
        <!--:key="index"-->
        <!--:label-width="formLabelWidth"-->
        <!--&gt;-->
        <!---->
        <!--</el-form-item>-->

      </el-col>
    </el-row>
  </div>
</template>
<style scope>
  .span-offsetcash {
    color: #00CCCD;
    margin: 0 10px 0 10px;
    display: inline-block;
    width: 150px;
  }
</style>
<script>
  import CommTreeViewDialog from "@/components/common/CommTreeViewDialog"; //引用部门人员选择对话框
  import {checkMenuBuyRight} from "@/api/login";

  export default {
    name: "FenTanDetailTemplate",
    props: [
      "uname",
      "uguid",
      "dname",
      "dserial",
      "formallowedit",
      "fentanDetailData", //已经提交保存的核销明细
      "isfentan",
      "totalFeeMoney",//费用总金额
    ],


    data() {

      return {
        fentanDetailjson: [
          {
            applyby: "",
            applybyguid: "",
            applybydname: "",
            applybydguid: "",
            fentanmoney: 0,
            hetongname: '',
            hetongserial: '',
            percent: 100,
          }
        ],
        formLabelWidth: "120px",
        // applyTreeOption: {
        //     title: "选择核销人",
        //     texts: "",
        //     ids: [],
        //     canSelectGroupTypeNode: true,
        //    rowindex: this.editDetailRowIndex,
        //     useRight: false,
        //     menuguid: "" //菜单guid
        // },
        editDetailRowIndex: 0,
        iffentan: this.isfentan,
        isClickEventProject: true,
      };
    },
    computed: {//计算属性
      applyTreeOption: function () {

        var detailrow = this.fentanDetailjson[this.editDetailRowIndex];
        var texts = "", ids = [];
        if (detailrow) {
          if (detailrow.applybyguid == "") {
            texts = detailrow.applybydname;
            ids = [detailrow.applybyguid];
          } else {
            texts = detailrow.applyby;
            ids = [detailrow.applybydserial];
          }
        }
        return {
          title: "选择分摊对象",
          rowindex: this.editDetailRowIndex,
          texts: texts,
          ids: ids,
          canSelectGroupTypeNode: true,
          useRight: false,
          menuguid: "" //菜单guid
        }
      },
      totalfeemoney:function () {
        return parseFloat(this.totalFeeMoney);
      }
    },
    methods: {

      //选择分摊人后事件
      afterSelectApply(ids, texts, arr, rowindex) {
        if (arr.length > 0) {
          var selectednode = arr[0];

          if (selectednode.id.length > 20) {
            //人员
            this.fentanDetailjson[rowindex]["applyby"] = selectednode.text;
            this.fentanDetailjson[rowindex]["applybyguid"] = selectednode.id;
            this.fentanDetailjson[rowindex]["applybydname"] = selectednode.parentText || "";
            this.fentanDetailjson[rowindex]["applybydguid"] = selectednode.parentId || "";
          }
          else {
            this.fentanDetailjson[rowindex]["applyby"] = "";
            this.fentanDetailjson[rowindex]["applybyguid"] = "";
            this.fentanDetailjson[rowindex]["applybydname"] = selectednode.text;
            this.fentanDetailjson[rowindex]["applybydguid"] = selectednode.id;
          }
        }

      },
      //初始化分摊
      initOffset() {
        this.iffentan = this.isfentan;
        this.fentanDetailjson = [];
        if (this.fentanDetailData) {
          this.fentanDetailjson = JSON.parse(this.fentanDetailData);
          //计算分摊比例
          for(var i=0;i<this.fentanDetailjson.length;i++){
            var fentanmoney=this.fentanDetailjson[i].fentanmoney;
            this.fentanDetailjson[i].percent=((fentanmoney/this.totalFeeMoney)*100).toFixed(2)
          }

        }
        if (this.fentanDetailjson.length == 0) {
          this.fentanDetailjson.push({
            applyby: "", //默认显示当前登录人
            applybyguid: "",
            applybydname: "",
            applybydguid: "",
            fentanmoney: 0,
            hetongname: '',
            hetongserial: '',
          });
        }
      },
      //添加分摊信息
      addOffset() {
        //先计算已经分配了多少
        var hasfentan=0;
        var haspercent=0;
        for(var i=0;i<this.fentanDetailjson.length;i++){
          hasfentan+=this.fentanDetailjson[i].fentanmoney;
          haspercent+=this.fentanDetailjson[i].percent;
        }
        var leftMoney=this.totalFeeMoney-hasfentan;
        var leftPercent=0;
        if(leftMoney<0){
          leftMoney=0;
        }
        else
        {
          leftMoney=leftMoney.toFixed(2);
           leftPercent=parseFloat(100)-haspercent;
          leftPercent=leftPercent.toFixed(2);
        }


        this.fentanDetailjson.push({
          applyby: "",
          applybyguid: "",
          applybydname: "",
          applybydguid: "",
          fentanmoney: leftMoney,
          percent:leftPercent,
          hetongname: '',
          hetongserial: '',
        });
        // this.$refs.applyTree.showTreeViewDialog();
      },
      //打开选择账户对话框
      openSelectApply(rowindex) {
        this.editDetailRowIndex = rowindex;
        this.$refs.applyTree.showTreeViewDialog();
      },
      //删除分摊信息
      removeOffset(offset) {
        var index = this.fentanDetailjson.indexOf(offset);
        if (index !== -1) {
          this.fentanDetailjson.splice(index, 1);
        }
        if (this.fentanDetailjson.length == 0) {
          this.fentanDetailjson.push({
            applyby: "", //默认显示当前登录人
            applybyguid: "",
            applybydname: "",
            applybydguid: "",
            fentanmoney: 0,
            hetongname: '',
            hetongserial: '',
          });
        }
      },
      //分摊对象按钮change事件
      FentanSwitchChange() {
        if (this.iffentan == 1) {
          //启用分摊
          if(this.fentanDetailjson.length==1&&this.fentanDetailjson[0].fentanmoney==0){
            var userinfo = JSON.parse(localStorage.getItem("userInfoModel"));
            this.fentanDetailjson[0].percent=100;
            this.fentanDetailjson[0].fentanmoney=this.totalFeeMoney;
            this.fentanDetailjson[0].applybydname=userinfo.dname;
            this.fentanDetailjson[0].applybydguid=userinfo.dserial;
            this.fentanDetailjson[0].applybydguid=userinfo.uguid;
            this.fentanDetailjson[0].applyby=userinfo.uname;
          }
        }
      },
      //分摊比例修改时
      onPercentChange(index){
        var percent=this.fentanDetailjson[index].percent;
        this.fentanDetailjson[index].fentanmoney=(this.totalFeeMoney*percent/100).toFixed(2);
      },
      //分摊金额修改，修改分摊比例
      onFentanmoneychange(index){
        var fentanmoney=this.fentanDetailjson[index].fentanmoney;
        this.fentanDetailjson[index].percent=((fentanmoney/this.totalFeeMoney)*100).toFixed(2)
      }
    },
    mounted() {
    },
    components: {
      //引用组件
      CommTreeViewDialog, //通用部门人员选择组件
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/oa/payform/FenTanDetailTemplate.vue